// An enemy cell carries its group as well, because every write about a standee is addressed through the
// group that owns it.
interface EnemyCell extends ParticipantRow {
    enemy: Enemy;
}
